import * as React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useI18n } from "../i18n/I18nProvider";
import type { FooterProps } from "../types/navigation";


export default function Footer({ handlePageChange }: FooterProps) {
  const { t } = useI18n();

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 1.2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `
          linear-gradient(
            90deg,
            #eaecf4 0%,
            #e0e3ef 50%,
            #eaecf4 100%
          )
        `,
        borderTop: "1px solid #0000000f",
      }}
    >
      <Stack spacing={0.4} alignItems="center">
        {/* TOP LINE — BRAND / RIGHTS */}
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#0000008c",
          }}
        >
          {t("footer.rights")}
        </Typography>

        {/* SECOND LINE — LINKS */}
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Typography
            onClick={() => handlePageChange("Terms")}
            sx={{
              fontSize: 12,
              cursor: "pointer",
              color: "#00000066",
              transition: "0.2s",
              "&:hover": {
                color: "#000000",
                textDecoration: "underline",
              },
            }}
          >
            Terms & Conditions
          </Typography>

          <Typography sx={{ fontSize: 11, color: "#00000030" }}>
            |
          </Typography>

          <Typography
            onClick={() => handlePageChange("Privacy")}
            sx={{
              fontSize: 12,
              cursor: "pointer",
              color: "#00000066",
              transition: "0.2s",
              "&:hover": {
                color: "#000000",
                textDecoration: "underline",
              },
            }}
          >
            Privacy Policy
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}